// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'components/styles/_media'

const PagerTitle = styled.p`
  font-size: 14px;
`
const PagerStrong = styled.strong`
  font-size: 14px;
  font-weight: bold;
`
const PagerDisplay = styled.span`
  margin-left: 8px;
  font-size: 14px;
`
const PagerList = styled.ul`
  margin: 12px 0 0 -8px;
  font-size: 0;
`
const PagerListItem = styled.li`
  display: inline-block;
  margin: 8px 0 0 8px;
`
const PagerNumberLink = styled.a`
  display: inline-block;
  width: 34px;
  height: 34px;
  border-radius: 3px;
  color: ${Colors.black};
  text-align: center;
  border: solid 1px ${Colors.grayD};
  background-color: ${Colors.white};
  font-size: 12px;
  line-height: 32px;

  &:hover {
    color: ${Colors.white};
    background-color: #999;
    border-color: #999;
  }

  &:not(:last-of-type) {
    margin-right: 8px;
  }

  &[data-number-status='current'] {
    background-color: ${Colors.grayE};
    font-weight: bold;

    &:hover {
      border-color: ${Colors.grayD};
      color: ${Colors.black};
    }
  }
`
const PagerLine = styled.div`
  border-top: 1px solid ${Colors.grayD};
  ${({ borderType }) =>
    borderType === 'minus' &&
    css`
      margin: 0 -12px;
    `};
`
const PagerContent = styled.div`
  padding-top: 24px;
`
const PagerNumberNotLink = PagerNumberLink.withComponent('span')
const PagerContainer = styled.div`
  ${({ layoutType }) =>
    layoutType === 'row' &&
    css`
    ${PagerContent} {  /* stylelint-disable-line */
      ${mediaMax.desktop`
        padding: 12px 0;
      `}
    ${PagerTitle} {  /* stylelint-disable-line */
      ${mediaMax.desktop`
        float: left;
        font-size: 14px;
      `}
    }
    ${PagerStrong} {  /* stylelint-disable-line */
      ${mediaMax.desktop`
        display: block;
        margin-bottom: 4px;
      `}
    }
    ${PagerDisplay} {  /* stylelint-disable-line */
      ${mediaMax.desktop`
        margin-left: 0;
        font-size: 12px;
      `}
    }
    ${PagerList} {  /* stylelint-disable-line */
      ${mediaMax.desktop`
        float: right;
        margin-top: -8px;
        font-size: 0;
      `}
    }
  `};
`

export type PropTypes = {
  totalCountDisplay: string,
  currentCountDisplay: string,
  currentPage: number,
  totalPages: number,
  previousPage: number,
  nextPage: number,
  windowSize: number,
  layoutType?: string,
  borderType: string,
  onChangePage?: (page: number) => void,
  getPageLink?: (page: number) => void,
}

export default (props: PropTypes) => {
  if (props.totalCount == 0) return null

  const shouldShowPageSize = props.windowSize * 2 + 1
  let startPage = props.currentPage - props.windowSize
  let endPage = props.currentPage + props.windowSize

  startPage = startPage < 1 ? 1 : startPage
  endPage = endPage > props.totalPages ? props.totalPages : endPage
  if (endPage - startPage + 1 < shouldShowPageSize) {
    if (endPage < props.totalPages) {
      endPage = startPage + props.windowSize * 2
    } else {
      endPage = props.totalPages
      startPage = endPage - props.windowSize * 2
    }
  }

  // ページ変更イベントがセットされていたらクリックイベントをジャックする
  const onClick = (e: Event, page: number) => {
    if (props.onChangePage) {
      e.preventDefault()
      // $FlowIssue: undefチェックしているのにエラーが出るので一旦無視
      props.onChangePage(page)
    }
  }

  let prevPagePath = '#'
  let nextPagePath = '#'
  if (props.getPageLink !== undefined) {
    prevPagePath = props.getPageLink(props.previousPage)
    // $FlowIssue: undefチェックしているのにエラーが出るので一旦無視
    nextPagePath = props.getPageLink(props.nextPage)
  }

  return (
    <PagerContainer className="clearfix" layoutType={props.layoutType}>
      <PagerLine borderType={props.borderType} />
      <PagerContent className="clearfix">
        <PagerTitle>
          <PagerStrong>{props.totalCountDisplay}</PagerStrong>
          <PagerDisplay>{props.currentCountDisplay}</PagerDisplay>
        </PagerTitle>
        <PagerList>
          {props.currentPage > 1 ? (
            <PagerListItem>
              <PagerNumberLink
                href={prevPagePath}
                data-number-status="prev"
                onClick={(e: Event) => onClick(e, props.previousPage)}
              >
                <i className="fa fa-angle-left" />
              </PagerNumberLink>
            </PagerListItem>
          ) : null}
          {Array.from(Array(props.totalPages), (_, index) => {
            const pageNumber = index + 1
            if (startPage > pageNumber || endPage < pageNumber) {
              return null
            } else if (props.currentPage === pageNumber) {
              return (
                <PagerListItem key={`pager_list_item_${index}`}>
                  <PagerNumberNotLink data-number-status="current">
                    {pageNumber}
                  </PagerNumberNotLink>
                </PagerListItem>
              )
            }

            let pagePath = '#'
            if (props.getPageLink !== undefined) {
              pagePath = props.getPageLink(pageNumber)
            }

            return (
              <PagerListItem key={`pager_list_item_${index}`}>
                <PagerNumberLink
                  href={pagePath}
                  onClick={(e: Event) => onClick(e, pageNumber)}
                >
                  {pageNumber}
                </PagerNumberLink>
              </PagerListItem>
            )
          })}
          {props.currentPage < props.totalPages ? (
            <PagerListItem>
              <PagerNumberLink
                href={nextPagePath}
                data-number-status="next"
                onClick={(e: Event) => onClick(e, props.nextPage)}
              >
                <i className="fa fa-angle-right" />
              </PagerNumberLink>
            </PagerListItem>
          ) : null}
        </PagerList>
      </PagerContent>
    </PagerContainer>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ListPager/index.jsx